<script setup lang="ts">
// Throwaway test harness for the new clinical visit page (visit-v11).
// Mounts VisitV11Page with `mock-backend` so it renders self-contained mock data
// with zero backend/env config. The production route is /healthcare/visits/:id.
import VisitV11Page from "@/components/visit-v11/VisitV11Page.vue";

definePage({
  meta: {
    navActiveLink: "healthcare-visits",
    permissionKey: "page.healthcare.visits",
  },
});

const route = useRoute();
const visitName = computed(() => {
  const query = route.query as Record<string, string | string[] | undefined>;
  const value = query.visitName ?? query.id ?? "";

  return String(Array.isArray(value) ? value[0] : value) || "VST-V11-0001";
});
</script>

<template>
  <VisitV11Page
    :visit-name="visitName"
    mock-backend
  />
</template>
